<template>
  <div id="table-wrap">
    <el-table
      :ref="refName"
      :data="tableData"
      :header-cell-style="tableHeaderColor"
      :style="tableWidth"
      :height="tableHeight"
      @selection-change="handleSelectionChange"
      @filter-change="filterChange"
    >
      <el-table-column
        type="selection"
        align="center"
        fixed="left"
        v-if="selectCtrl"
        width="50"
      >
      </el-table-column>
      <!-- <el-table-column
        type="index"
        align="center"
        :label="labelNo"
        fixed="left"
        v-if="orderCtrl"
        width="50"
      >
      </el-table-column> -->
      <el-table-column
        v-for="{ prop, label, width, btn, obj } in tableProps"
        align="center"
        show-overflow-tooltip
        :prop="prop"
        :key="prop"
        :label="label"
        :fixed="prop === 'handle' ? 'right' : false"
        :width="width"
        :filters="
          prop === 'lock'
            ? [
                { text: '已锁定', value: 1 },
                { text: '未锁定', value: 0 },
                { text: '正在锁定', value: 2 }
              ]
            : null
        "
      >
        <template slot-scope="scope">
          <div v-if="obj" class="omitText">
            <span>{{ scope.row | filterObj(prop) }}</span>
          </div>

          <div
            class="omitText"
            v-if="
              prop === 'updated_at' ||
                prop === 'created_at' ||
                prop === 'updatedAt'
            "
          >
            <span>{{ scope.row[prop] | filterDate }}</span>
          </div>

          <div class="omitText" v-else-if="prop === 'tag'">
            <span>{{
              scope.row[prop] !== null ? scope.row[prop].name : "-"
            }}</span>
          </div>
          <div class="omitText" v-else-if="prop === 'users'">
            <span>{{
              scope.row[prop].length ? scope.row[prop][0].nickname : "-"
            }}</span>
          </div>
          <div class="omitText" v-else-if="prop === 'lock'">
            <span>{{ scope.row[prop] | filterLock }}</span>
          </div>
          <div
            class="omitText"
            v-else-if="prop === 'devices' || prop === 'orgs'"
          >
            <span>{{
              scope.row[prop] !== null ? scope.row[prop].length : "-"
            }}</span>
          </div>
          <div class="omitText" v-else-if="prop === 'apps'">
            <span v-for="(item, index) in scope.row[prop]" :key="item.id">
              {{ item.name }}
              <i v-if="index !== scope.row[prop].length - 1">、</i>
            </span>
          </div>
          <div v-else-if="prop === 'move'" class="appTable-move">
            <i
              class="move-up"
              v-if="scope.$index !== 0"
              @click="tableSort('up', scope)"
            ></i>
            <i
              class="move-down"
              v-if="scope.$index !== tableData.length - 1"
              @click="tableSort('down', scope)"
            ></i>
          </div>
          <div v-else-if="prop === 'handle'">
            <span
              v-if="!scope.row.lock"
              class="delBtn"
              @click="tableHandle('锁定', scope)"
              >{{ $t("user.lock") }}</span
            >
            <span v-else class="delBtn" @click="tableHandle('解锁', scope)">{{
              $t("user.unlock")
            }}</span>
            <span
              :class="btnStyle(item)"
              v-for="item in btn"
              :key="item"
              plain
              @click="tableHandle(item, scope)"
              >{{ item }}</span
            >
          </div>
          <span v-else class="omitText">{{
            scope.row[prop] !== null ? scope.row[prop] : "-"
          }}</span>
        </template>
      </el-table-column>
    </el-table>
    <transition name="fade">
      <DelFacility
        :text="text"
        @delHandleFacilitys="delHandleFacilitys"
        v-if="delFacility"
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ResizeMixin from "@/mixins/resize";
import DelFacility from "@/components/delFacility";

export default {
  components: {
    DelFacility
  },
  computed: {
    ...mapGetters(["hasData", "delFacility"]),
    labelNo() {
      return this.$t("commonMsg.No");
    }
  },
  mixins: [ResizeMixin],
  props: {
    refName: {
      type: String,
      default: "delFacility"
    },
    tableWidth: {
      type: String,
      default: "width:100%"
    },
    tableData: {
      type: Array,
      default: () => []
    },
    tableProps: {
      type: Array
    },
    selectCtrl: {
      type: Boolean,
      default: false
    },
    orderCtrl: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      selectDataIds: [],
      scopeItem: null,
      handleType: "",
      text: ""
    };
  },

  filters: {
    filterObj(obj, value) {
      let temp = value.split(".");
      if (temp.length === 2 && obj[temp[0]]) {
        return obj[temp[0]][temp[1]];
      } else if (temp.length === 3 && obj[temp[0]] && obj[temp[0]][temp[1]]) {
        return obj[temp[0]][temp[1]][temp[2]];
      }
    }
  },

  methods: {
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f7f7f7;font-weight: 500;";
      }
    },

    btnStyle(item) {
      let className;
      switch (item) {
        case this.$t("commonMsg.checkDetails"):
        case this.$t("commonMsg.edit"):
          className = "checkDetailsBtn";
          break;
        case this.$t("user.unbind"):
        case this.$t("user.resetPsw"):
        case this.$t("user.lock"):
        case this.$t("user.unlock"):
        case "操作记录":
          className = "delBtn";
          break;

        default:
          break;
      }
      return className;
    },

    // 表格上下移动排序
    tableSort(type, scope) {
      this.emitEvn(type, scope, "tableSort");
    },

    // 表格操作按钮
    tableHandle(type, scope) {
      if (type === this.$t("user.unbind")) {
        this.handleType = type;
        this.scopeItem = scope;
        this.$store.commit("windowHandle", "delFacility");
      } else if (type === "锁定") {
        this.text = "是否锁定该设备";
        this.handleType = type;
        this.scopeItem = scope;
        this.$store.commit("windowHandle", "delFacility");
      } else if (type === "解锁") {
        this.text = "是否解锁该设备";
        this.handleType = type;
        this.scopeItem = scope;
        this.$store.commit("windowHandle", "delFacility");
      } else {
        this.emitEvn(type, scope, "tableHandle");
      }
    },

    //  确认解绑
    delHandleFacilitys() {
      if (this.handleType === "锁定") {
        this.emitEvn(this.$t("user.lock"), this.scopeItem, "tableHandle");
      } else if (this.handleType === "解锁") {
        this.emitEvn(this.$t("user.unlock"), this.scopeItem, "tableHandle");
      } else if (this.handleType === this.$t("user.unbind")) {
        this.emitEvn(this.$t("user.unbind"), this.scopeItem, "tableHandle");
      }
    },

    emitEvn(type, scope, evn) {
      let obj = {
        type: type,
        data: scope
      };
      this.$emit(evn, obj);
    },
    filterChange(data) {
      this.$emit("tableFilterChange", data);
    },
    handleSelectionChange(data) {
      this.$emit("tableSelectionChange", data);
    }
  }
};
</script>

<style lang="scss" scoped>
#table-wrap {
  height: 100%;
  .appTable-move {
    > i {
      display: inline-block;
      width: 22px;
      height: 22px;
      cursor: pointer;
      font-size: 20px;
      margin: 0 5px;
      font-weight: bold;
      vertical-align: middle;
    }
    .move-up {
      background: url("~@/assets/img/cmb_move_up.png") no-repeat;
    }
    .move-down {
      background: url("~@/assets/img/cmb_move-down.png") no-repeat;
    }
  }
}
</style>
